import clsx from 'clsx';
import { FC, PropsWithChildren } from 'react';

import { FormStepTransition } from 'src/general/transitions/FormStepTransition/FormStepTransition';

type Props = PropsWithChildren & {
  className?: string;
  id?: string;
};

export const AuthFormContainer: FC<Props> = ({ children, className, id }) => {
  return (
    <FormStepTransition>
      <div className={clsx('auth-form-container', className)} data-testid={id}>
        {children}
      </div>
    </FormStepTransition>
  );
};
